export default __webpack_public_path__ + "static/media/logo.025a81d0.png";